module.exports = __webpack_public_path__ + "templates.dialog.product.quick_cart-885af431.html";